import { Countries, CountryList } from '@percent/admin-dashboard/api/actions/countries/countriesService.types'

export const mapCountriesToSelectOptions = (countriesList?: CountryList) =>
  (countriesList ?? []).map((country: Countries) => ({ label: country.name, value: country.code }))
